import { Divider, Skeleton } from "@mui/material";

export const PriceInfoLoading = (props) => {
  return (
    <>
      <Skeleton height={15} sx={{ mt: 4 }} />
      <Skeleton height={15} sx={{ mt: 2 }} />
      <Skeleton height={15} sx={{ mt: 2 }} />
      <Skeleton height={15} sx={{ mt: 2 }} />
      <Skeleton height={15} sx={{ mt: 2 }} />
      <Skeleton height={15} sx={{ mt: 2 }} />
      <Skeleton height={15} sx={{ mt: 2 }} />
      <Divider sx={{ my: 3 }} />

      <Skeleton height={70} sx={{}} />
    </>
  );
};
